import { createSelector } from 'reselect'

const pollSelector = state => state.poll

const poll_settings_selector = createSelector(
	[pollSelector],
	pollState => ({
		entityUID: pollState.entityUID,
	})
)

export default poll_settings_selector
